import {createTheme, ThemeOptions} from "@mui/material/styles";
import {red} from "@mui/material/colors";

const colorSchemes: Record<"light" | "dark", ThemeOptions> = {
    light: {
        palette: {
            mode: "light",
            primary: {
                main: "#20A4A9",
                contrastText: "#fff",
            },
            secondary: {
                main: "#fff",
                contrastText: "#20A4A9",
            },
            error: {
                main: red.A400,
            },
            background: {
                default: "#fcfcfc",
                paper: "#fff",
            },
            text: {
                primary: "#00274d",
                secondary: "#526c86",
            },
        },
    },
    dark: {
        palette: {
            mode: "dark",
            primary: {
                main: "#20A4A9",
                contrastText: "#fff",
            },
            secondary: {
                main: "#fff",
                contrastText: "#20A4A9",
            },
            error: {
                main: red[700],
            },
            background: {
                default: "#121212",
                paper: "#1e1e1e",
            },
            text: {
                primary: "#fff",
                secondary: "#bbb",
            },
        },
    },
};


const typography: ThemeOptions["typography"] = {
    fontFamily: `Poppins, sans-serif`,
    h1: {
        fontSize: "2rem",
        fontWeight: 400,
    },
    h2: {
        fontSize: "1.75rem",
        fontWeight: 400,
    },
    h3: {
        fontSize: "1.5rem",
        fontWeight: 400,
    },
    h4: {
        fontSize: "1.25rem",
        fontWeight: 400,
    },
    body1: {
        fontSize: "1rem",
    },
    body2: {
        fontSize: "0.875rem",
    },
};

const shape: ThemeOptions["shape"] = {
    borderRadius: 8,
};

const theme = createTheme({
    cssVariables: {
        colorSchemeSelector: "data-mui-color-scheme",
        cssVarPrefix: "medendo",
    },
    ...colorSchemes.light,
    typography,
    shape,
    // Here we override the default styles for the Drawer component
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "outlined",
                size: "medium",
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: "32px",
                    gap: '24px',
                    borderRadius: '20px',
                },
            },
        },
        MuiStack: {
            defaultProps: {
                spacing: "24px",
            },
        },
        MuiFormControl: {
            defaultProps: {
                fullWidth: true,
            },
        },
        MuiSelect: {
            defaultProps: {
                variant: "outlined",
            },
        },
        MuiMenu: {
            styleOverrides: {
                paper: {
                    padding: "12px",
                    borderRadius: "6px",
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    height: "48px",
                    minWidth: "120px",
                    padding: "8px 22px",
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                slotProps: {
                    paper: {
                        style: {
                            margin: 0,
                            padding: '16px',
                            border: '1px solid',
                            borderColor: 'primary.main',
                        }
                    }
                }
            }
        },
        MuiDialogTitle: {
            defaultProps: {
                sx: {
                    p: 0,
                    m: 0,
                    mt: '8px',
                    mb: '2px',
                    lineHeight: 1,
                    fontSize: '1.125rem',
                    fontWeight: 600
                }
            }
        },
        MuiDialogContent: {
            defaultProps: {
                sx: {
                    p: 0,
                    m: 0,

                }
            }
        },
        MuiDialogActions: {
            defaultProps: {
                sx: {
                    p: 0,
                    m: 0,

                }
            }
        },
    },
});

export default theme;
